require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./com.wsscode.blog.components.charts.js");

require("./helix.core.js");

require("./helix.dom.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.blog.pathom_updates_5.js");
goog.provide('com.wsscode.blog.pathom_updates_5');
com.wsscode.blog.pathom_updates_5.runner__GT_label = new cljs.core.PersistentArrayMap(null, 5, ["p3-serial-cp", "Pathom 3 Cached Plan", "p3-serial", "Pathom 3", "p2-serial", "Pathom 2 Serial", "p2-async", "Pathom 2 Async", "p2-parallel", "Pathom 2 Parallel"], null);

com.wsscode.blog.pathom_updates_5.calculate_difference = function com$wsscode$blog$pathom_updates_5$calculate_difference(results) {
  if (cljs.core.seq(results)) {
    var fastest = cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.min, cljs.core.vals(results));
    return cljs.core.reduce_kv(function (out, id, mean_ms) {
      return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(out, id, mean_ms / fastest);
    }, cljs.core.PersistentArrayMap.EMPTY, results);
  } else {
    return cljs.core.PersistentArrayMap.EMPTY;
  }
};

com.wsscode.blog.pathom_updates_5.PathomProfile5 = function () {
  var G__24519 = function com$wsscode$blog$pathom_updates_5$PathomProfile5_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__24520 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__24523 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24520, 0, null);
    var map__24523__$1 = (!(map__24523 == null) ? map__24523.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24523.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24523) : map__24523;
    var data = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__24523__$1, new cljs.core.Keyword(null, "data", "data", -232669377));
    return helix.core.get_react().createElement("div", function () {
      var obj24526 = {
        "style": function () {
          var obj24528 = {
            "border": helix.impl.props.__GT_js("6px solid #000"),
            "padding": helix.impl.props.__GT_js("13px"),
            "margin": helix.impl.props.__GT_js("16px 0")
          };
          return obj24528;
        }()
      };
      return obj24526;
    }(), helix.core.get_react().createElement("div", function () {
      var obj24530 = {
        "style": function () {
          var obj24532 = {
            "height": helix.impl.props.__GT_js("400px"),
            "display": helix.impl.props.__GT_js("flex")
          };
          return obj24532;
        }()
      };
      return obj24530;
    }(), com.wsscode.blog.components.charts.bar_chart(cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "indexBy", "indexBy", -1728110523), new cljs.core.Keyword(null, "labelFormat", "labelFormat", 1295545482), new cljs.core.Keyword(null, "enableLabel", "enableLabel", 1998443242), new cljs.core.Keyword(null, "colors", "colors", 1157174732), new cljs.core.Keyword(null, "groupMode", "groupMode", -1379146863), new cljs.core.Keyword(null, "keys", "keys", 1068423698), new cljs.core.Keyword(null, "padding", "padding", 1660304693), new cljs.core.Keyword(null, "margin", "margin", -995903681), new cljs.core.Keyword(null, "data", "data", -232669377)], ["name", ">-.3f", true, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "scheme", "scheme", 90199613), "category10"], null), "grouped", new cljs.core.PersistentVector(null, 5, 5, cljs.core.PersistentVector.EMPTY_NODE, ["p3-serial-cp", "p3-serial", "p2-serial", "p2-async", "p2-parallel"], null), 0.3, new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "top", "top", -1856271961), 20, new cljs.core.Keyword(null, "right", "right", -452581833), 10, new cljs.core.Keyword(null, "bottom", "bottom", -1550509018), 50, new cljs.core.Keyword(null, "left", "left", -399115937), 40], null), data]))), helix.core.get_react().createElement("table", function () {
      var obj24534 = {
        "style": function () {
          var obj24536 = {
            "margin": helix.impl.props.__GT_js("0"),
            "fontSize": helix.impl.props.__GT_js("0.9rem"),
            "lineHeight": helix.impl.props.__GT_js("1rem")
          };
          return obj24536;
        }()
      };
      return obj24534;
    }(), helix.core.get_react().createElement("thead", null, helix.core.get_react().createElement("tr", null, helix.core.get_react().createElement("th", null, "Runner"), helix.core.get_react().createElement("th", null, "Mean"), helix.core.get_react().createElement("th", null, "Variance"))), helix.core.get_react().createElement("tbody", null, function () {
      var data_clj = cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(cljs.core.first(cljs.core.js__GT_clj.cljs$core$IFn$_invoke$arity$1(data)), "name");
      var differences = com.wsscode.blog.pathom_updates_5.calculate_difference(data_clj);

      var iter__4529__auto__ = function com$wsscode$blog$pathom_updates_5$PathomProfile5_render_$_iter__24537(s__24538) {
        return new cljs.core.LazySeq(null, function () {
          var s__24538__$1 = s__24538;

          while (true) {
            var temp__5804__auto__ = cljs.core.seq(s__24538__$1);

            if (temp__5804__auto__) {
              var s__24538__$2 = temp__5804__auto__;

              if (cljs.core.chunked_seq_QMARK_(s__24538__$2)) {
                var c__4527__auto__ = cljs.core.chunk_first(s__24538__$2);
                var size__4528__auto__ = cljs.core.count(c__4527__auto__);
                var b__24540 = cljs.core.chunk_buffer(size__4528__auto__);

                if (function () {
                  var i__24539 = 0;

                  while (true) {
                    if (i__24539 < size__4528__auto__) {
                      var k = cljs.core._nth(c__4527__auto__, i__24539);

                      var v = cljs.core.get.cljs$core$IFn$_invoke$arity$2(data_clj, k);
                      cljs.core.chunk_append(b__24540, helix.core.get_react().createElement("tr", function () {
                        var obj24542 = {
                          "key": cljs.core.str.cljs$core$IFn$_invoke$arity$1(k)
                        };
                        return obj24542;
                      }(), helix.core.get_react().createElement("td", null, com.wsscode.blog.pathom_updates_5.runner__GT_label.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.blog.pathom_updates_5.runner__GT_label.cljs$core$IFn$_invoke$arity$1(k) : com.wsscode.blog.pathom_updates_5.runner__GT_label.call(null, k)), helix.core.get_react().createElement("td", null, [cljs.core.str.cljs$core$IFn$_invoke$arity$1(parseFloat(v).toFixed(3)), "ms"].join('')), helix.core.get_react().createElement("td", null, [cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.core.get.cljs$core$IFn$_invoke$arity$2(differences, k).toFixed(3)), "x"].join(''))));
                      var G__24574 = i__24539 + 1;
                      i__24539 = G__24574;
                      continue;
                    } else {
                      return true;
                    }

                    break;
                  }
                }()) {
                  return cljs.core.chunk_cons(cljs.core.chunk(b__24540), com$wsscode$blog$pathom_updates_5$PathomProfile5_render_$_iter__24537(cljs.core.chunk_rest(s__24538__$2)));
                } else {
                  return cljs.core.chunk_cons(cljs.core.chunk(b__24540), null);
                }
              } else {
                var k = cljs.core.first(s__24538__$2);
                var v = cljs.core.get.cljs$core$IFn$_invoke$arity$2(data_clj, k);
                return cljs.core.cons(helix.core.get_react().createElement("tr", function () {
                  var obj24546 = {
                    "key": cljs.core.str.cljs$core$IFn$_invoke$arity$1(k)
                  };
                  return obj24546;
                }(), helix.core.get_react().createElement("td", null, com.wsscode.blog.pathom_updates_5.runner__GT_label.cljs$core$IFn$_invoke$arity$1 ? com.wsscode.blog.pathom_updates_5.runner__GT_label.cljs$core$IFn$_invoke$arity$1(k) : com.wsscode.blog.pathom_updates_5.runner__GT_label.call(null, k)), helix.core.get_react().createElement("td", null, [cljs.core.str.cljs$core$IFn$_invoke$arity$1(parseFloat(v).toFixed(3)), "ms"].join('')), helix.core.get_react().createElement("td", null, [cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.core.get.cljs$core$IFn$_invoke$arity$2(differences, k).toFixed(3)), "x"].join(''))), com$wsscode$blog$pathom_updates_5$PathomProfile5_render_$_iter__24537(cljs.core.rest(s__24538__$2)));
              }
            } else {
              return null;
            }

            break;
          }
        }, null, null);
      };

      return iter__4529__auto__(new cljs.core.PersistentVector(null, 5, 5, cljs.core.PersistentVector.EMPTY_NODE, ["p3-serial-cp", "p3-serial", "p2-serial", "p2-async", "p2-parallel"], null));
    }())));
  };

  if (goog.DEBUG === true) {
    var G__24553 = G__24519;
    G__24553.displayName = "com.wsscode.blog.pathom-updates-5/PathomProfile5";
    return G__24553;
  } else {
    return G__24519;
  }
}();

goog.exportSymbol('com.wsscode.blog.pathom_updates_5.PathomProfile5', com.wsscode.blog.pathom_updates_5.PathomProfile5);
Object.defineProperty(module.exports, "runner__GT_label", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.pathom_updates_5.runner__GT_label;
  }
});
Object.defineProperty(module.exports, "calculate_difference", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.pathom_updates_5.calculate_difference;
  }
});
Object.defineProperty(module.exports, "PathomProfile5", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.pathom_updates_5.PathomProfile5;
  }
});